module.exports = __webpack_public_path__ + "img/A13d_2.G.1.3-GR7b.91ff382b.jpg";